import Swiper from 'swiper';

export default {
  init() {

    /* Permalinks
    ---------------------------------------------------------------------------------------------------- */
    
    $('*[data-permalink]').unbind().click(function(e){

      e.preventDefault();
      e.stopPropagation();
      
      var el = $(this), 
          permalink = $(el).data('permalink'), 
          newWindow = $(el).data('permalink-new-window'), 
          windowFeatures = ''; 
          
          if(newWindow) {
            window.open(permalink, '_blank', windowFeatures);
            return;
          }
          
          $(el).addClass('loading-permalink');
          
          window.location.href = permalink;
      
    });
    
    
    /* Header
    ---------------------------------------------------------------------------------------------------- */

    $('#nav').on('initNav', function(){
      
      var el = $(this);
      
      $('.toggle-menu').click(function(e){
        e.preventDefault();
        
        if($('body').hasClass('showing-menu')) {
          $(el).trigger('closeMenu');
        } else {
          $(el).trigger('openMenu');
        }
        
      });

      $('.open-menu').click(function(e){
        e.preventDefault();
        $(el).trigger('openMenu');
      });
      
      $('.overlay, .close-menu', el).click(function(e){
        e.preventDefault();
        $(el).trigger('closeMenu');
      });
      
      $('a', el).click(function(e){
        e.stopPropagation();
      });
      
    }).on('openMenu', function(){
      
      if($('body').hasClass('hiding-menu')) {
        return;
      }
      
      $('body').addClass('showing-menu');
      
    }).on('closeMenu', function(){
      
      $('body').removeClass('showing-menu').addClass('hiding-menu');
      
      setTimeout(function() {
        $('body').removeClass('hiding-menu');
        
        // Closing any open sub menus
        $('.menu-item-has-children-link').trigger('closeSubMenu');
        
      }, 300);
      
    }).trigger('initNav');
    

    /* Nav Menu
    ---------------------------------------------------------------------------------------------------- */
    
    $('.menu-item-has-children-link.depth-0').on('click', function(e){ 
  
      var el         = $(this), 
          parentEl   = $(el).parent(),
          isOpen     = $(parentEl).hasClass('open'); // eslint-disable-line no-unused-vars
          
      //if(!isOpen) {
        e.preventDefault();
        $(el).trigger('toggleSubMenu');
      //}      
  
    }).on('toggleSubMenu', function() {
      
      var el = $(this), 
          parentEl    = $(el).parent(),
          //subMenuEl   = $('.sub-menu-container.depth-1', parentEl),
          isOpen      = $(parentEl).hasClass('open');
  
          if(isOpen) {
            $(el).trigger('closeSubMenu');
          } else {
            $(el).trigger('openSubMenu');
          }
      
    }).on('openSubMenu', function() {
      
      var el = $(this), 
          parentEl       = $(el).parent(),
          subMenuEl     = $('.sub-menu-container.depth-0', parentEl),
          containerEl   = $(subMenuEl), 
          contentEl      = $('.sub-menu.depth-0', containerEl), 
          openHeight     = $(contentEl).height();
          
          $(el).blur();
          
          $(parentEl).addClass('opening');
          $(containerEl).clearQueue().animate({height: openHeight }, 250, function() {
            $(parentEl).addClass('open').removeClass('opening');
            $(containerEl).attr('style', '');
          });
          
          $('.menu-item-has-children-link.depth-0').not(el).trigger('closeSubMenu');
          
          
    }).on('closeSubMenu', function() {
      
      var el = $(this), 
          parentEl       = $(el).parent(),
          subMenuEl     = $('.sub-menu-container.depth-0', parentEl),
          containerEl   = $(subMenuEl), 
          contentEl      = $('.sub-menu.depth-0', containerEl), 
          openHeight     = $(contentEl).height(),
          closeHeight   = 0;
          
        if(!$(parentEl).hasClass('open')) {
          return;
        } 
        
        $(parentEl).addClass('closing').removeClass('open');         
        
        $(containerEl).clearQueue().css('height', openHeight+'px').animate({height: closeHeight }, 250, function() {
          $(parentEl).removeClass('open').removeClass('closing');
          $(containerEl).attr('style', '');
        });
      
    });
    
    $('#nav-secondary .menu-item-has-children-link').click(function(e){
      e.preventDefault();
    });
    
    
    
    /* Slider
    ---------------------------------------------------------------------------------------------------- */

    $('.section--slider').on('initSlider', function(){

      var el = $(this), 
          autoplayDelay = parseInt($(el).data('autoplay')),
          //sliderEl = $('.slider', el), 
          slider = new Swiper($('.slider', el), {
              pagination: {
                el: $('.swiper-pagination', el),
                type: 'bullets',
                clickable: true,
              },
              navigation: {
                nextEl: $('.swiper-button-next', el),
                prevEl: $('.swiper-button-prev', el),
              },
              autoplay: (autoplayDelay) ? {delay: autoplayDelay} : false,
              slidesPerView: 1,
              spaceBetween: 0, 
              runCallbacksOnInit: true,
          });
      
      
      slider.on('slideChangeStart', function(swiper){
        
        if(swiper.isBeginning) {
          $(el).addClass('is-beginning');
        } else {
          $(el).removeClass('is-beginning');
        }
        
        if(swiper.isEnd) {
          $(el).addClass('is-end');
        } else {
          $(el).removeClass('is-end');
        }
        
      });
      
  
    }); //.trigger('initSlider');
    
    
    setTimeout(function() {
      $('.section--slider').trigger('initSlider');
    }, 500);
    
    
    /* Accordion Content
    ---------------------------------------------------------------------------------------------------- */

    $('.accordion-content').on('initAccordion', function(){
      
      var el = $(this);
      
      if((window.location.hash.length > 1) && $(window.location.hash, el).length) {

        setTimeout(function() {
            
          var itemEl = $(window.location.hash, el).closest('.item');
          $(itemEl).trigger('openItem');
          
          var offset = -($('#header').height());
          $(window).scrollTo($(itemEl), 500, {offset:offset});
            
        }, 500);
        
      }
      
  
    }).trigger('initAccordion');
    
    
    
    $('.accordion-content .item').on('initAccordionItem', function(){

      var el = $(this);
      
      $('.trigger-toggle-accordion-item', el).click(function(e){
        e.preventDefault();
        $(el).trigger('toggleItem');
      });
  
    }).on('toggleItem', function(e) { // eslint-disable-line no-unused-vars
      
      var el = $(this), 
          isOpen = $(el).hasClass('open');
  
          if(isOpen) {
            $(el).trigger('closeItem');
          } else {
            $(el).trigger('openItem');
          }
      
    }).on('openItem', function(e) { // eslint-disable-line no-unused-vars
      
      var el = $(this), 
          containerEl   = $('.item-content', el), 
          contentEl      = $('.inner', containerEl), 
          openHeight = $(contentEl).height();
          
          $(el).addClass('opening');
          $(containerEl).clearQueue().animate({height: openHeight }, 250, function() {
            $(el).addClass('open').removeClass('opening');
            
            var offset = -($('#header').height() + 60);  
            $(window).scrollTo($(el), 350, {offset:offset});
            
          });
          
          $('.accordion-content .item').not(el).trigger('closeItem');
          
          
    }).on('closeItem', function(e) { // eslint-disable-line no-unused-vars
      
      var el = $(this), 
          containerEl   = $('.item-content', el), 
          closeHeight   = 0;
          
        $(el).addClass('closing').removeClass('open');
        $(containerEl).clearQueue().animate({height: closeHeight }, 250, function() {
          $(el).removeClass('open').removeClass('closing')
        });
      
    }).trigger('initAccordionItem');
    

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js